const INITIAL_STATE = {
    atividadesFornecedor: {
      data: []
    },
    atividadeFornecedor: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'ATIVIDADES_FORNECEDOR_FETCH':
        return { ...state, atividadesFornecedor: action.payload }
      default:
        return state
    }
  }